import Banner from "../Banner/Banner"
import Categorias from "../Categorias/Categorias"
import Vendidos from "../Vendidos/Vendidos"
import Servicios from "../Servicios/Servicios"

const Home = () => {
    return (
        <>
        <Banner/>
        <Categorias/>
        <Vendidos/>
        <Servicios/>
        </>
    )
}

export default Home